import { Dialog } from '@mui/material';

import RetailerNetworkUserDetailsLocationGroupsTable from '../components/retailer-network-user-details-location-groups-table/retailer-network-user-details-location-groups-table.container';

type RetailerNetworkAddUserToLocationGroupsDialogProps = {
  retailerNetworkUuid: string;
  open: boolean;
  setDialogOpen: (open: boolean) => void;
  selectLocationGroupUuids: (locationGroupUuids: string[]) => void;
};

export const RetailerNetworkAddUserToLocationGroupsDialog = ({
  retailerNetworkUuid,
  open,
  setDialogOpen,
  selectLocationGroupUuids,
}: RetailerNetworkAddUserToLocationGroupsDialogProps) => {
  const onClose = () => setDialogOpen(false);

  return (
    <Dialog onClose={onClose} open={open} fullWidth maxWidth='md'>
      <RetailerNetworkUserDetailsLocationGroupsTable
        retailerNetworkUuid={retailerNetworkUuid}
        selectLocationGroupUuids={selectLocationGroupUuids}
        onClose={onClose}
      />
    </Dialog>
  );
};
